/*
 * ms-facet-fallback.js
 * --------------------------------------------------------------------------
 * The facet filter UI is built on customized built-in elements
 * (<form is="facet-form">, <a is="facet-link">, <button is="facet-apply-button">).
 * WebKit (Safari on macOS and ALL iOS browsers) has never shipped support for
 * customized built-ins, so those constructors never run there and the
 * "submit the form when a filter changes" behaviour never gets wired up.
 * Result: on Safari/iOS, checking a filter or moving the price range does
 * nothing, so filtering appears completely broken.
 *
 * This is a small, dependency free fallback. It runs ONLY in browsers that
 * lack customized built-in support, and only does what the native facet JS
 * would have done: submit the facet form (a plain GET to the search/collection
 * URL with the chosen filters) when an input inside it changes. In Chrome and
 * Firefox it detects native support and does nothing, so there is no double
 * submit. The remove/clear links already work in Safari because they are real
 * <a href> anchors.
 */
(function () {
  if (window.__msFacetFallback) return;
  window.__msFacetFallback = true;

  // Feature detect customized built-in support by defining a throwaway element
  // and checking whether an `is=` instance actually upgrades to the class.
  var supported = false;
  try {
    var probe = 'ms-cbi-probe';
    if (!window.customElements.get(probe)) {
      window.customElements.define(probe, class extends HTMLButtonElement {}, { extends: 'button' });
    }
    var el = document.createElement('button', { is: probe });
    supported = el instanceof window.customElements.get(probe);
  } catch (e) {
    supported = false;
  }
  if (supported) return; // Chrome / Firefox: the native facet JS handles it.

  var submitForm = function (form) {
    if (!form) return;
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
  };

  // Auto submit the sidebar facet form (update-on-change) when a filter changes.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var form = t.closest('form.facets-vertical[update-on-change]');
    if (form) submitForm(form);
  });

  // The mobile filter drawer uses an explicit "Apply" button instead of
  // update-on-change. Make that button submit its form natively too.
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var applyBtn = t.closest('[is="facet-apply-button"], .facets-drawer__floating-apply button, .facets-drawer__floating-apply [type="submit"]');
    if (!applyBtn) return;
    var form = applyBtn.closest('form.facets-vertical') || document.querySelector('form.facets-vertical:not([update-on-change])');
    if (form) {
      e.preventDefault();
      submitForm(form);
    }
  });
})();
